import React from "react";
import { Link } from "react-router-dom";

export const SectionHeader = ({ overline, title, subtitle, align = "left", maxWidth = "max-w-2xl" }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} ${maxWidth}`}>
    {overline && <p className="ess-overline">{overline}</p>}
    <h2 className="font-display mt-4 text-4xl md:text-5xl text-ess-emerald leading-[1.05]">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-5 text-ess-slate text-base md:text-[17px] leading-relaxed">
        {subtitle}
      </p>
    )}
    <span className="ess-divider mt-6" />
  </div>
);

export const GoldButton = ({ children, ...props }) => (
  <button
    {...props}
    className={
      "inline-flex items-center justify-center bg-ess-gold text-ess-charcoal px-7 py-4 text-[12px] uppercase tracking-[0.24em] font-semibold hover:bg-ess-gold-deep hover:text-white transition-all duration-300 " +
      (props.className || "")
    }
  >
    {children}
  </button>
);

export const EmeraldButton = ({ children, as = "button", to, ...props }) => {
  const cls =
    "inline-flex items-center justify-center bg-ess-emerald text-white px-7 py-4 text-[12px] uppercase tracking-[0.24em] font-medium hover:bg-ess-emerald-dark transition-all duration-300 hover:-translate-y-[1px] " +
    (props.className || "");
  if (as === "link") {
    return (
      <Link to={to} {...props} className={cls}>
        {children}
      </Link>
    );
  }
  return (
    <button {...props} className={cls}>
      {children}
    </button>
  );
};

export const GhostButton = ({ children, as = "button", to, ...props }) => {
  const cls =
    "inline-flex items-center justify-center border border-ess-emerald text-ess-emerald px-7 py-4 text-[12px] uppercase tracking-[0.24em] font-medium hover:bg-ess-emerald hover:text-white transition-all duration-300 " +
    (props.className || "");
  if (as === "link") {
    return (
      <Link to={to} {...props} className={cls}>
        {children}
      </Link>
    );
  }
  return (
    <button {...props} className={cls}>
      {children}
    </button>
  );
};

export const PageHero = ({ overline, title, subtitle, image, children }) => (
  <section className="relative overflow-hidden bg-ess-emerald text-white">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-ess-emerald/95 via-ess-emerald/85 to-ess-emerald" />
      </div>
    )}
    <div className="ess-container relative py-28 md:py-36">
      {overline && <p className="ess-overline text-ess-gold">{overline}</p>}
      <h1 className="font-display mt-5 text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-6 max-w-2xl text-white/80 text-lg leading-relaxed">{subtitle}</p>
      )}
      {children}
    </div>
  </section>
);
